import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import { get, post, requests, patch } from '@partsbadger/utils';

import { MaterialProps } from '@partsbadger/types';

class MaterialStore {
    materials: Array<MaterialProps> = [];
    topMaterials: Array<MaterialProps> = [];

    constructor() {
        makeObservable(this, {
            materials: observable,
            topMaterials: observable,

            getMaterials: action,
            getTopMaterials: action,
        });
    }

    getMaterials() {
        requests
            .get(`/customer/materials/`)
            .then(data => {
                runInAction(() => {
                    this.materials = data.results;
                });
            })
            .catch(error => {
                console.error(error);
            });
    }

    getTopMaterials() {
        requests
            .get(`/customer/materials/top-materials/`)
            .then(data => {
                runInAction(() => {
                    this.topMaterials = data;
                });
            })
            .catch(error => {
                console.error(error);
            });
    }
}

const materialStore = new MaterialStore();

export default materialStore;
